import { Component, OnInit, Input } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { element } from 'protractor';
import { CoursesQuizCreateQuestionComponent } from '../courses-quiz-create-question/courses-quiz-create-question.component';
import { CourseQuizService } from '../../../../api/Services/maintenance/course-quiz.service';
import { ToastrService } from 'ngx-toastr';
import { CoursesQuizCreateHeaderComponent } from '../courses-quiz-create-header/courses-quiz-create-header.component';
import { CoursesQuizCreateBodyComponent } from '../courses-quiz-create-body/courses-quiz-create-body.component';
import { DialogService } from '../../../../common/dialog.service';

@Component({
  selector: 'app-courses-quiz-create',
  templateUrl: './courses-quiz-create.component.html',
  styleUrls: ['./courses-quiz-create.component.css']
})
export class CoursesQuizCreateComponent implements OnInit {

  @Input() data;
  coquti_tx_description:string='';
  coquti_bi_id:number=0;

  dataQuiz:any[];
  constructor(
    private toastr: ToastrService,
    private courseQuizServices: CourseQuizService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) { }
  bPermission:Boolean = false;
  ngOnInit(): void {

    if (this.data.tabData.element) {
      this.bPermission = true;
      this.coquti_tx_description = this.data.tabData.element.coquti_tx_description;
      this.coquti_bi_id = this.data.tabData.element.coquti_bi_id;
      console.log(this.data.tabData.element);
      this.loadQuestion();
    }
  }

  addquestion()
  {
    
      const dialogConfig = new MatDialogConfig();
       
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = this.coquti_bi_id;
        dialogConfig.minWidth = '50%';
       
  
        const dialogRef = this.dialog.open(CoursesQuizCreateQuestionComponent, dialogConfig);
  
        dialogRef.afterClosed().subscribe(result => {
           this.loadQuestion();
        });
      
      
  
     
  }
  deletequestion(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta pregunta?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuiz(element.coqu_bi_id).subscribe(
        data => {
          if (data['sucess']) {
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }
  loadQuestion(){
    this.courseQuizServices.GetAlltQuiz(this.coquti_bi_id).subscribe(
      data => {
        console.log(data);

        if (data['sucess']) {
        
          console.log(data['data']);
          this.dataQuiz = data['data'];
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }

  addHeader(element){
    const dialogConfig = new MatDialogConfig();
       
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = element;
    dialogConfig.minWidth = '50%';
   

    const dialogRef = this.dialog.open(CoursesQuizCreateHeaderComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
       this.loadQuestion();
    });
  }
  addBody(element){
    const dialogConfig = new MatDialogConfig();
       
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = element;
    dialogConfig.minWidth = '50%';
   

    const dialogRef = this.dialog.open(CoursesQuizCreateBodyComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
       this.loadQuestion();
    });
  }

  deleteBody(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta fila?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuizBody(element.coqubo_bi_id).subscribe(
        data => {
         
          if (data['sucess']) {
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }
  deleteHeader(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta columna?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuizHeader(element.coquhe_bi_id).subscribe(
        data => {
         
          if (data['sucess']) {
            
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }

  
}
